/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_TitleInputs */



/**
* | output |
* | --- |
* | "ADR Setup & Configuration" |
*
* @param {Options_Adr_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_title = /** @type {((inputs?: Options_Adr_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Configuration ADR")
	if (locale === "de") return /** @type {LocalizedString} */ ("ADR-Einrichtung und -Konfiguration")
	if (locale === "it") return /** @type {LocalizedString} */ ("Configurazione e impostazione ADR")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройка и конфигурация ADR")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración y configuración de ADR")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("ADR 设置和配置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ADRのセットアップと構成")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एडीआर सेटअप और कॉन्फ़िगरेशन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configuração e instalação do ADR")
	return /** @type {LocalizedString} */ ("ADR Setup & Configuration")
});